/**
 * Listado de expresiones regulares
 *
 * @readonly
 * @enum {RegExp}
 */
export const REGEX_KEY = {
  PHONE: /^[0-9]{9}$/,
  DOCUMENT: /^[0-9]{8}[a-zA-Z]{1}$/,
};

export const DOCUMENT_REGEX = {
  DNI: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i,
  NIE: /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i,
  PASSPORT: /^[A-Z0-9]{6,9}$/,
}
